import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Menu, MenuItem } from "@mui/material";
import LanguageRoundedIcon from "@mui/icons-material/LanguageRounded";
import { SUPPORTED_LANGS } from "../i18n";

export default function LanguageSwitcher({ dense }: { dense?: boolean }) {
  const { i18n } = useTranslation();
  const [anchor, setAnchor] = React.useState<null | HTMLElement>(null);
  const current = (i18n.resolvedLanguage || i18n.language || "nl").slice(0, 2).toUpperCase();

  return (
    <>
      <Button
        onClick={(e: React.MouseEvent<HTMLElement>) => setAnchor(e.currentTarget)}
        startIcon={<LanguageRoundedIcon sx={{ fontSize: 18 }} />}
        size={dense ? "small" : "medium"}
        sx={{ color: "text.secondary", minWidth: 0, textTransform: "none" }}
        aria-label="Change language"
      >
        {current}
      </Button>
      <Menu anchorEl={anchor} open={!!anchor} onClose={() => setAnchor(null)}>
        {SUPPORTED_LANGS.map((lng) => (
          <MenuItem
            key={lng}
            selected={current === lng.toUpperCase()}
            onClick={() => {
              i18n.changeLanguage(lng);
              setAnchor(null);
            }}
          >
            {lng.toUpperCase()}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
